export * from './obj';
import * as obj from './obj';
export default obj;